<template>
        <div class="container-menu-left-flex-wedding">
                <h1>Menu</h1>
                <a v-scroll-to="{ element: '#sala', duration: 1600 }" href="#intro" class="btn-contact">SALA</a>
                <a v-scroll-to="{ element: '#cozinha', duration: 1600 }" href="#temas" class="btn-contact">COZINHA</a>
                <a v-scroll-to="{ element: '#escritorio', duration: 1600 }" href="#install" class="btn-contact">ESCRITÓRIO</a>
                <a v-scroll-to="{ element: '#quarto', duration: 1600 }" href="#imagens" class="btn-contact">QUARTO</a>
                <a v-scroll-to="{ element: '#banherio', duration: 1600 }" href="#cores" class="btn-contact">BANHEIRO</a>
                <a v-scroll-to="{ element: '#lavandeira', duration: 1600 }" href="#banners" class="btn-contact">LAVANDERIA</a>
             
               

        </div>
</template>


<script>

export default {
 data(){
        return{    
        }
    }
};

</script>

<style scoped>
.container-menu-left-flex-wedding{
        display: flex;
        flex-direction: column;
        width: 220px;
        background-color: #f5f5f5;
      

}

.container-menu-left-flex-wedding a {
          font-size: 18px;
      color: #020202cf;
      text-decoration: none;
      padding: 12px 20px;     
}

.container-menu-left-flex-wedding h1{
      font-size: 30px;
      color: #496e4c;
      text-decoration: none;
      padding: 10px 20px;
     
        
}


.container-menu-left-flex h1{
      font-size: 30px;
      color: #b03434;
      text-decoration: none;
      padding: 10px 20px;
     
        
}
.container-menu-left-flex a{
      font-size: 20px;
      color: #020202cf;
      text-decoration: none;
      padding: 12px 20px;     
}


@media (max-width: 1024px) {
  .container-menu-left-flex{
          display: none;
  }
}


</style>
